import { useMemo } from 'react';
import { areFilterStatesEqual, useFilterContext } from '@medifind/zustand';

export const useActiveCount = () => {
  const filters = useFilterContext();

  const count = useMemo(() => {
    return Object.keys(filters.enabledValues).filter((filterName) => {
      if (!filters.values[filterName]) return false;

      const filter = filters.states[filterName];
      return !filter.dontIncludeInCount && !areFilterStatesEqual(filter.getInitialState(), filter);
    }).length;
  }, [...filters.dependencies]);
  return count;
};
